module.exports = __webpack_public_path__ + "fonts/HarmonyOS_Sans_SC_Thin.0288aaa6.ttf";